import { render, staticRenderFns } from "./HistoricoDePrecios.vue?vue&type=template&id=312bcab4&"
import script from "./HistoricoDePrecios.vue?vue&type=script&lang=js&"
export * from "./HistoricoDePrecios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports